<!--执行通知书列表页面-->
<template>
<div class="pagination_comp">
  <!-- 插槽：暂时没用 -->
  <slot name="张三"></slot>
  <!-- 页数大于1才显示 -->
  <el-pagination
    v-if="type!='1'"
    @current-change="handleCurrentChange"
    :current-page="PAGE"
    :page-size="PAGESIZE"
    :layout="layouts[type]"
    :page-sizes="[5,10, 20, 30, 50 ,100]"
    :total="total"
    @size-change="handleSizeChange"
  ></el-pagination>
           
</div>
    
</template>
<script>
export default {
  name:'paginations',
  data: function() {
    return {
      PAGE:1,
      PAGESIZE:10,
      count:100,
      layouts:['total, sizes, prev, pager, next, jumper','','prev, pager, next']
    };
  },
  props:
  // ['page','pageSize','total'],
  {
    page:Number,
    pageSize:Number,
    total:Number,
    /*
      普通类型：0
      pdf类型：1
    */
    type:{
      default:0,
      type:[Number],
    }
  },
  methods: {
    handleCurrentChange(val){
      this.PAGE=val;
      // console.log('PAGESIZE:'+this.PAGESIZE+',PAGE:'+this.PAGE)
      this.$emit('paginationFn',[this.PAGE,this.PAGESIZE])
    },
    handleSizeChange(val){
      this.PAGESIZE=val;
      // pagesize变化的时候，page重置未1
      this.PAGE=1;
      // console.log('PAGESIZE:'+this.PAGESIZE+',PAGE:'+this.PAGE)
      this.$emit('paginationFn',[this.PAGE,this.PAGESIZE])
    },
  },
  mounted() {
    this.PAGESIZE=this.pageSize;
    this.PAGE=this.page
  },
  watch:{
    'page':function(val){
      this.PAGE=val;
    },
    'pageSize':function(val){
      this.PAGESIZE=val;
    },

  },
};
</script>
<style >
  .pagination_comp .el-pagination__editor{
    vertical-align: middle;
  }
</style>




// WEBPACK FOOTER //
// src/components/pagination.vue